import React from "react";
import { ChevronRight, Sparkles } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
import { useNS7Images } from "./ns7/useNS7Images";
import CoachingCampsIntro from "./coaching-camps/CoachingCampsIntro";
import CoachingCampsMobile from "./coaching-camps/CoachingCampsMobile";
import CoachingCampsDesktop from "./coaching-camps/CoachingCampsDesktop";

const NewSectionSeven = () => {
  const isMobile = useIsMobile();
  const { bannerImageUrl, videoImageUrl, infoImageUrl } = useNS7Images();

  return (
    <div className="relative" id="ns7">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/20 to-black/50" />
      <div className="relative bg-gradient-to-r from-[#243949] to-[#517fa4] [&>*]:relative">
        <div className="container mx-auto px-4 py-8 md:py-16">
          <h3 className="text-lg md:text-xl font-bold text-white mb-8 text-center uppercase">
            Kompass-Camps
          </h3>
          
          {/* Untertitel über dem Bild */}
          <p className="text-white text-center mb-8 px-4 font-bold">
            Finde deinen Kompass für die Zeit nach dem Abi auf einem einzigartigen Natur-Adventure Camp
          </p>
          
          <CoachingCampsIntro 
            imageUrl={bannerImageUrl} 
            isMobile={isMobile} 
            section="ns7-banner"
          />

          {/* NS3-ähnliche Struktur nach dem Bild */}
          {isMobile ? (
            <div className="mt-8 space-y-4">
              <div className="group relative bg-white/10 backdrop-blur-sm py-2.5 px-4 rounded-lg shadow-lg border border-white/20 ml-6">
                <div className="absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2">
                  <div className="w-12 h-12 rounded-full bg-[#8E9196] flex items-center justify-center">
                    <ChevronRight className="w-6 h-6 text-white" />
                  </div>
                </div>
                <p className="text-base md:text-lg text-white pl-4 text-left">
                  4 Tage in der norditalienischen Wildnis
                </p>
              </div>
              
              <div className="group relative bg-white/10 backdrop-blur-sm py-2.5 px-4 rounded-lg shadow-lg border border-white/20 ml-6">
                <div className="absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2">
                  <div className="w-12 h-12 rounded-full bg-[#8E9196] flex items-center justify-center">
                    <ChevronRight className="w-6 h-6 text-white" />
                  </div>
                </div>
                <p className="text-base md:text-lg text-white pl-4 text-left">
                  Auf einer Hütte - ohne Strom & Internet - wir kochen selber auf dem Feuer
                </p>
              </div>
              
              <div className="group relative bg-white/10 backdrop-blur-sm py-2.5 px-4 rounded-lg shadow-lg border border-white/20 ml-6">
                <div className="absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2">
                  <div className="w-12 h-12 rounded-full bg-[#8E9196] flex items-center justify-center">
                    <ChevronRight className="w-6 h-6 text-white" />
                  </div>
                </div>
                <p className="text-base md:text-lg text-white pl-4 text-left">
                  Ohne Ablenkung auf dich und dein Herz hören
                </p>
              </div>
              
              <div className="group relative bg-white/10 backdrop-blur-sm py-2.5 px-4 rounded-lg shadow-lg border border-white/20 ml-6">
                <div className="absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2">
                  <div className="w-12 h-12 rounded-full bg-[#8E9196] flex items-center justify-center">
                    <ChevronRight className="w-6 h-6 text-white" />
                  </div>
                </div>
                <p className="text-base md:text-lg text-white pl-4 text-left">
                  Intensive Gemeinschaft mit 7-13 Gleichaltrigen
                </p>
              </div>
            </div>
          ) : (
            <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
              <div className="group relative bg-white/10 backdrop-blur-sm py-2.5 px-4 rounded-lg shadow-lg border border-white/20 ml-6">
                <div className="absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2">
                  <div className="w-12 h-12 rounded-full bg-[#8E9196] flex items-center justify-center">
                    <ChevronRight className="w-6 h-6 text-white" />
                  </div>
                </div>
                <p className="text-base md:text-lg text-white pl-4 text-left">
                  4 Tage in der norditalienischen Wildnis
                </p>
              </div>
              
              <div className="group relative bg-white/10 backdrop-blur-sm py-2.5 px-4 rounded-lg shadow-lg border border-white/20 ml-6">
                <div className="absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2">
                  <div className="w-12 h-12 rounded-full bg-[#8E9196] flex items-center justify-center">
                    <ChevronRight className="w-6 h-6 text-white" />
                  </div>
                </div>
                <p className="text-base md:text-lg text-white pl-4 text-left">
                  Auf einer Hütte - ohne Strom & Internet - wir kochen selber auf dem Feuer
                </p>
              </div>
              
              <div className="group relative bg-white/10 backdrop-blur-sm py-2.5 px-4 rounded-lg shadow-lg border border-white/20 ml-6">
                <div className="absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2">
                  <div className="w-12 h-12 rounded-full bg-[#8E9196] flex items-center justify-center">
                    <ChevronRight className="w-6 h-6 text-white" />
                  </div>
                </div>
                <p className="text-base md:text-lg text-white pl-4 text-left">
                  Ohne Ablenkung auf dich und dein Herz hören
                </p>
              </div>
              
              <div className="group relative bg-white/10 backdrop-blur-sm py-2.5 px-4 rounded-lg shadow-lg border border-white/20 ml-6">
                <div className="absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2">
                  <div className="w-12 h-12 rounded-full bg-[#8E9196] flex items-center justify-center">
                    <ChevronRight className="w-6 h-6 text-white" />
                  </div>
                </div>
                <p className="text-base md:text-lg text-white pl-4 text-left">
                  Intensive Gemeinschaft mit 7-13 Gleichaltrigen
                </p>
              </div>
            </div>
          )}
          
          {/* Graue hervorgehobene Box wie in NS3 */}
          <div className="mt-8">
            <div className="relative bg-gradient-to-r from-[#D3E4FD] to-[#F1F0FB] py-2.5 px-4 rounded-lg shadow-lg border border-white/20 ml-6">
              <div className="absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2">
                <div className="w-12 h-12 rounded-full bg-[#8E9196] flex items-center justify-center">
                  <Sparkles className="w-6 h-6 text-white" />
                </div>
              </div>
              <p className="text-base md:text-lg text-[#222222] pl-4 text-left">
                Durch intensives Coaching, Stille, Gemeinschaft, Abenteuer und Natur in 4 Tagen deinen Kompass finden
              </p>
            </div>
          </div>

          {/* Button wie in NS3 */}
          <div className="flex justify-center mt-8">
            <button 
              onClick={() => window.location.href = '/alle-infos'}
              className="bg-white/10 hover:bg-white/20 text-white border-2 border-[#ECA505] px-4 py-1.5 rounded-lg text-sm font-semibold transition-all cursor-pointer flex items-center gap-2"
            >
              Du hast Lust und bist bereit für diese Challenge? <div className="flex items-center">
                <ChevronRight className="w-4 h-4" />
                <ChevronRight className="w-4 h-4 -ml-2" />
              </div>
            </button>
          </div>

          {/* Categories section - use appropriate component based on screen size */}
          <div className="mt-12">
            {isMobile ? (
              <CoachingCampsMobile 
                preachingImageUrl={infoImageUrl} 
                passionsImageUrl={videoImageUrl} 
              />
            ) : (
              <CoachingCampsDesktop 
                preachingImageUrl={infoImageUrl} 
                passionsImageUrl={videoImageUrl} 
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewSectionSeven;